// Who a direct conversation is WITH.
//
// ⚠️ A DIRECT conversation is not guaranteed to have exactly two participants.
// Dana joins a thread when somebody @mentions her in it, and a recognition
// card can join its actor too. The old rule — "the first participant who is
// not me" — then picked whoever happened to be first in the array.
//
// Reported from production: starting a direct message with one colleague
// opened a conversation labelled **Dana**. Only that colleague, because hers
// was the thread Dana had been pulled into. Nothing was wrong with the
// conversation; the label was reading the wrong participant.
import { DANA_BOT_USER_ID } from './types';

/**
 * The human this direct conversation is with.
 *
 * ⚠️ Falls back to the bot deliberately: a direct conversation WITH Dana has
 * no human counterpart, and it must still say Dana rather than going blank.
 * Excluding her unconditionally would fix one label by breaking another.
 */
export const directCounterpart = (
  participantUserIds: readonly (string | undefined | null)[] | undefined | null,
  selfId: string | undefined | null,
): string | undefined => {
  const others = (participantUserIds ?? []).filter(
    (id): id is string => !!id && id !== selfId,
  );
  return others.find((id) => id !== DANA_BOT_USER_ID) ?? others[0];
};
